export default {
    en: {
        id: 'diagram4b2-5',
        blocks: [
            {
                index: '1',
                task: 'S = Many major industries have stopped growing or are in decline',
                title: "S = "
            },
            {
                index: '2',
                task: 'C = (Assumption is that growth is threatened because market is saturated)',
                title: "C = "
            },
            {
                index: '3',
                task: 'Q = (Is that a correct assumption?)',
                title: "Q = "
            },
            {
                index: '4',
                task: 'A = No, it is because there has been a failure of management',
                title: "A = No",
                disabled: true
            },
        ],
        answers: [
            {
                index: '2',
                title: '(Assume Y is the cause)'
            },
            {
                index: '3',
                title: '(Is Y the cause?) '
            },
            {
                index: '1',
                title: 'X happening'
            },
        ],
        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
        correctAnswers: 3,
        note: `Note on Marketing Myopia: Here both the Complication and the Question are unstated, as they are implied by the Answer. It is a clever and effective way to get more quickly to the main point.
               But unless you are a real expert in your subject, you would be wise to avoid it.<br/>
               HELP YOU AVOID WHY? QUESTIONS<br/>
               You will from time to time feel tempted to write an introduction that leads to a Why? question, as below.<br/>
                <div class="scq__note-reverse">
                <div>
                    <span style="font-weight: bold">Why did it happen?</span>
                    <span style="font-weight: bold">Tower of Babel</span>
                </div>
                <div>
                    <span style="width: 35%">A = Attempted X</span>
                    <span style="width: 65%">S = Tower of Babel was man’s first major engineering failure</span>
                </div>
                <div>
                    <span style="width: 35%">C = Didn’t work</span>
                    <span style="width: 65%">C =  But project appears to have had all the major prerequisites for success</span>
                </div>
                <div>
                    <span style="width: 35%">Q = Why not?</span>
                    <span style="width: 65%">Q = Why did it fail?</span>
                </div>
            </div>
            As I mentioned in the last video, I do not like to have Why? as a question in a business document.  In general business documents should have a bias toward action, as that tends to be more helpful in focusing you on the actions you want your reader to take.  Why? questions, as you will see in the examples below, tend to encourage greater exposition of the problem instead of getting straight to the answer.  And they invariably lead to deductive arguments on the Key Line level.  They also lead to relatively frivolous discussion of the subject at hand.  You will be pleased to know that, in most cases, they can be easily converted to a How? question.<br/>
            But unless you are a real expert in your subject, you would be wise to avoid it.`
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/exercise5.js